import React, { useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useGetMyOutletsQuery } from "../slices/OutletSlice";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import OutletDetailsScreen from "./OutletDetailsScreen";
import { useGetMyOutletFoodItemsQuery } from "../slices/FoodItemSilce";

const ViewOutletsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [selectedOutletId, setSelectedOutletId] = useState(null);
  const {
    data: outlets,
    isLoading,
    error,
    refetch,
  } = useGetMyOutletsQuery({
    token: userInfo?.token,
  });

  return (
    <>
      <Row>
        <Col>
          <Row className="mt-4">
            <h5>View Outlets</h5>
            <Col>
              {isLoading ? (
                <Loader />
              ) : error ? (
                <Message>
                  {error?.data?.error || "Error fetching outlets"}
                </Message>
              ) : (
                <Table
                  striped
                  bordered
                  hover
                  responsive="sm"
                  className="table-custom"
                >
                  <thead className={`${userInfo.themeColor}ThemeThead`}>
                    <tr>
                      <th>Outlet Name</th>
                      <th>City</th>
                      <th>Contact Info</th>
                    </tr>
                  </thead>
                  <tbody>
                    {outlets?.length > 0 ? (
                      outlets.map((outlet) => (
                        <tr key={outlet._id}>
                          <td>
                            <a
                              onClick={() =>
                                navigate(`/outletDetails/${outlet._id}`)
                              }
                              style={{
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                            >
                              {outlet?.outletName}
                            </a>
                          </td>

                          <td>{outlet?.companyId?.companyCity || "N/A"}</td>
                          <td>{outlet?.outletContact || "N/A"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3}>
                          <Message>No outlets found.</Message>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ViewOutletsScreen;
